import { useMemo } from "react";
import { ReactFlow, Background, type Node, type Edge } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { Box } from "@mui/material";
import type { PrepJobGraph } from "../../../types/prep";
import { useAppCustomStyles } from "../../../assets/theme/custom/hooks";
import { graphToFlow } from "../utils/graphAdapter";
import PrepDslQueryNode from "./nodes/PrepDslQueryNode";
import PrepAdaptorQueryNode from "./nodes/PrepAdaptorQueryNode";
import PrepOpenApiQueryNode from "./nodes/PrepOpenApiQueryNode";
import PrepOutputNode from "./nodes/PrepOutputNode";

const nodeTypes = {
  prepDslQuery: PrepDslQueryNode,
  prepAdaptorQuery: PrepAdaptorQueryNode,
  prepOpenApiQuery: PrepOpenApiQueryNode,
  prepOutput: PrepOutputNode,
};

type Props = {
  graph?: PrepJobGraph | null;
  height?: number;
};

export default function PrepGraphThumbnail({ graph, height = 72 }: Props) {
  const custom = useAppCustomStyles();
  const flow = useMemo(() => (graph ? graphToFlow(graph) : { nodes: [], edges: [] }), [graph]);

  if (!graph?.nodes?.length) {
    return (
      <Box
        sx={custom.components.dataPrep.graphThumbnailEmpty(height)}
      />
    );
  }

  return (
    <Box
      sx={custom.components.dataPrep.graphThumbnail(height)}
    >
      <ReactFlow
        nodes={flow.nodes as Node[]}
        edges={flow.edges as Edge[]}
        nodeTypes={nodeTypes}
        fitView
        nodesDraggable={false}
        nodesConnectable={false}
        elementsSelectable={false}
        panOnDrag={false}
        zoomOnScroll={false}
        zoomOnPinch={false}
        zoomOnDoubleClick={false}
        proOptions={{ hideAttribution: true }}
      >
        <Background gap={8} size={0.5} />
      </ReactFlow>
    </Box>
  );
}
